import React, {useState, createContext, useEffect} from 'react';
import QUERY_ALL_CATEGORIES from "./Queries/AllCategories";
import QUERY_ALL_SECTORS from "./Queries/AllSectors";
import QUERY_ALL_BRANDS from "./Queries/AllBrands";
import QUERY_PRODUCTS from "./Queries/Products";
import { useQuery } from '@apollo/client'
import {setCategoryPageInfo} from "./Functions/Helpers";
import {WooUserProvider} from "./WooUserContext";

export const WooContext = createContext();

export const WooProvider = (props) => {
    const defaultOffset = (props.defaultPerPage * props.defaultPage);
    const acctCustomer = props.acctCustomer||0;
    const [currentCategory, setCurrentCategory] = useState({databaseId: parseInt(props.defaultCategoryId)});
    const [pageInfo, setPageInfo] = useState({databaseId: parseInt(props.defaultCategoryId)});
    const [currentSector, setCurrentSector] = useState({databaseId: parseInt(props.defaultSectorId)});
    const [currentBrand, setCurrentBrand] = useState({databaseId: parseInt(props.defaultBrandId)});
    const [hireOrSale, setHireOrSale] = useState(props.defaultHireOrSale||'');
    const [orderBy, setOrderBy] = useState({field: 'TOTAL_SALES', order: 'DESC'});
    const [paged, setPaged] = useState({size: parseInt(props.defaultPerPage), offset: parseInt(defaultOffset)});
    const [filtersLoaded, setFiltersLoaded]= useState(false);
    const productCategories = useQuery(QUERY_ALL_CATEGORIES),
        productSectors = useQuery(QUERY_ALL_SECTORS),
        productBrands = useQuery(QUERY_ALL_BRANDS),
        products = useQuery(QUERY_PRODUCTS,{
            variables: {
                currentCategoryId: currentCategory.databaseId,
                currentSectorId: currentSector.databaseId,
                attribute: currentBrand.databaseId ? 'pa_brand' : '',
                hireSale: hireOrSale,
                attributeTerm: currentBrand.name,
                ...orderBy,
                ...paged
            }
        });
    const store = {
        currentCategoryState: [currentCategory, setCurrentCategory],
        currentSectorState: [currentSector, setCurrentSector],
        currentBrandState: [currentBrand, setCurrentBrand],
        hireOrSaleState: [hireOrSale, setHireOrSale],
        pageInfoState: [pageInfo, setPageInfo],
        orderByState: [orderBy, setOrderBy],
        pagedState: [paged, setPaged],
        filtersLoadedState: [filtersLoaded, setFiltersLoaded],
        productCategories,
        productSectors,
        productBrands,
        acctCustomer,
        products,
    };
    useEffect(() => {
        if(productSectors.data && productCategories.data && productBrands.data) setFiltersLoaded(true);
        if(productCategories.data && currentCategory.databaseId) {
            const categoryItem = productCategories.data.productCategories.nodes.filter(categoryItem => categoryItem.databaseId === currentCategory.databaseId);
            setCurrentCategory(categoryItem[0]);
            setPageInfo(categoryItem[0]);
        }
        if(productSectors.data && currentSector.databaseId) {
            const sectorItem = productSectors.data.productSectors.nodes.filter(sectorItem => sectorItem.databaseId === currentSector.databaseId);
            setCurrentSector(sectorItem[0]);
            if (!currentBrand.databaseId && !currentCategory.databaseId) setPageInfo(sectorItem[0]); return;
        }
        if(productBrands.data && currentBrand.databaseId) {
            const brandItem = productBrands.data.paBrands.nodes.filter(brandItem => brandItem.databaseId === currentBrand.databaseId);
            setCurrentBrand(brandItem[0]);
            if (!currentSector.databaseId && !currentCategory.databaseId) setPageInfo(brandItem[0]);
        }
    }, [productBrands, productSectors, productCategories, currentBrand, currentCategory, currentSector]);
    useEffect(() => {
        if (currentCategory.databaseId) {
            setCategoryPageInfo(currentCategory);
            return;
        }
        if (currentBrand.databaseId && currentSector.databaseId) return;
        setCategoryPageInfo(currentSector.databaseId ? currentSector : currentBrand);
    }, [currentCategory, currentSector, currentBrand]);
    return (
        <WooUserProvider>
            <WooContext.Provider value={store}>
                {props.children}
            </WooContext.Provider>
        </WooUserProvider>
    );
};

